import clsx from 'clsx';

import { Input } from '../Input';
import { SearchIcon } from './SearchIcon';

export type SearchBarProps = {
  search: string;
  className?: string;
  withBorder?: boolean;
  size?: 'small' | 'medium';
  onSearch: (newSearch: string) => void;
};

export const SearchBar: React.FC<SearchBarProps> = ({
  search,
  onSearch,
  className,
  withBorder = true,
  size = 'medium',
}) => {
  const isSmall = size === 'small';

  return (
    <Input
      value={search}
      onChange={onSearch}
      placeholder="Search"
      className={className}
      prefix={<SearchIcon />}
      withBorder={withBorder}
      inputClassName={clsx(isSmall ? 'py-1.5 pl-14 text-small' : 'pl-20')}
      inputRoundedClassName="rounded-card"
      defaultSizeClass={isSmall ? 'w-full' : 'min-w-[14rem] md:min-w-[20rem]'}
    />
  );
};
